module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Regular.c00e087.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Regular.otf
// module id = sQ1Q
// module chunks = 6